export default __webpack_public_path__ + "static/pro@768-990eeb9ab238fad5b96cc8545fd0a41b.jpg";